import React from 'react'
import { BrowserRouter, Routes, Route, Outlet, Link, Navigate } from 'react-router-dom'
import { TenantProvider, useTenant } from './contexts/TenantContext'
import { ToastProvider } from './contexts/ToastContext'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import Loading from './components/Loading'
import Header from './components/Header'
import Footer from './components/Footer'
import { FaixaTeste } from './components/AvisoTeste'
import AdminLayout from './components/AdminLayout'
import RotaProtegida from './components/RotaProtegida'
import ComPermissao from './components/ComPermissao'
import PaginaInicio from './pages/PaginaInicio'
import Agendar from './pages/Agendar'
import Confirmacao from './pages/Confirmacao'
import PoliticaPrivacidade from './pages/PoliticaPrivacidade'
import TermosCondicoes from './pages/TermosCondicoes'
import Login from './pages/admin/Login'
import Managers from './pages/admin/Managers'
import AgendaDia from './pages/admin/AgendaDia'
import DetalheAgendamento from './pages/admin/DetalheAgendamento'
import AgendaMes from './pages/admin/AgendaMes'
import Bloqueios from './pages/admin/Bloqueios'
import NovaMarcacao from './pages/admin/NovaMarcacao'
import Profissionais from './pages/admin/Profissionais'
import Servicos from './pages/admin/Servicos'
import Salas from './pages/admin/Salas'
import Configuracoes from './pages/admin/Configuracoes'
import ConfiguracoesSuperAdmin from './pages/admin/ConfiguracoesSuperAdmin'
import Clientes from './pages/admin/Clientes'
import DetalheCliente from './pages/admin/DetalheCliente'
import Cobrar from './pages/admin/Cobrar'
import RedefinirPassword from './pages/admin/RedefinirPassword'
import AlterarPassword from './pages/admin/AlterarPassword'
import Promocoes from './pages/admin/Promocoes'
import Permissoes from './pages/admin/Permissoes'
import Relatorios from './pages/admin/Relatorios'
import Faturacao from './pages/admin/Faturacao'
import CancelarPromocoes from './pages/CancelarPromocoes'

function PublicLayout() {
  return (
    <>
      <FaixaTeste />
      <Header />
      <Outlet />
      <Footer />
    </>
  )
}

function RotaSuper() {
  const { isSuper, carregando } = useAuth()
  if (carregando) return <Loading />
  if (!isSuper) return <Navigate to="/admin" replace />
  return <Outlet />
}

function PaginaNaoEncontrada() {
  return (
    <main style={{ maxWidth: '480px', margin: '80px auto', padding: '0 24px', textAlign: 'center' }}>
      <p style={{ fontSize: '64px', marginBottom: '16px' }}>404</p>
      <h2 style={{ marginBottom: '12px' }}>Página não encontrada</h2>
      <p style={{ color: 'var(--cor-texto-suave)', marginBottom: '28px' }}>
        A página que procura não existe.
      </p>
      <Link to="/" className="btn-primario" style={{ textDecoration: 'none', display: 'inline-block' }}>
        Voltar ao Início
      </Link>
    </main>
  )
}

function AppInterna() {
  const { carregandoTenant, erroTenant } = useTenant()

  if (carregandoTenant) return <div style={{ padding: '64px 24px' }}><Loading /></div>

  if (erroTenant) return (
    <main style={{ maxWidth: '480px', margin: '80px auto', padding: '0 24px', textAlign: 'center' }}>
      <p style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</p>
      <h2 style={{ marginBottom: '12px' }}>Espaço não encontrado</h2>
      <p style={{ color: 'var(--cor-texto-suave)' }}>{erroTenant}</p>
    </main>
  )

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<PaginaInicio />} />
            <Route path="/agendar" element={<Agendar />} />
            <Route path="/confirmacao" element={<Confirmacao />} />
            <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
            <Route path="/termos" element={<TermosCondicoes />} />
            <Route path="/cancelar-promocoes" element={<CancelarPromocoes />} />
            <Route path="*" element={<PaginaNaoEncontrada />} />
          </Route>

          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/redefinir-password" element={<RedefinirPassword />} />
          <Route path="/admin/alterar-password" element={<AlterarPassword />} />

          <Route path="/admin" element={<RotaProtegida />}>
            <Route element={<AdminLayout />}>
              <Route index element={<ComPermissao pagina="agenda_dia"><AgendaDia /></ComPermissao>} />
              <Route path="agendamento/:id" element={<ComPermissao pagina="agenda_dia"><DetalheAgendamento /></ComPermissao>} />
              <Route path="mes" element={<ComPermissao pagina="agenda_mes"><AgendaMes /></ComPermissao>} />
              <Route path="nova-marcacao" element={<ComPermissao pagina="nova_marcacao"><NovaMarcacao /></ComPermissao>} />
              <Route path="bloqueios" element={<ComPermissao pagina="bloqueios"><Bloqueios /></ComPermissao>} />
              <Route path="clientes" element={<ComPermissao pagina="clientes"><Clientes /></ComPermissao>}>
                <Route path=":id" element={<DetalheCliente />} />
              </Route>
              <Route path="clientes/:id/cobrar" element={<ComPermissao pagina="clientes"><Cobrar /></ComPermissao>} />
              <Route path="promocoes" element={<ComPermissao pagina="promocoes"><Promocoes /></ComPermissao>} />
              <Route path="profissionais" element={<ComPermissao pagina="profissionais"><Profissionais /></ComPermissao>} />
              <Route path="servicos" element={<ComPermissao pagina="servicos"><Servicos /></ComPermissao>} />
              <Route path="salas" element={<ComPermissao pagina="salas"><Salas /></ComPermissao>} />
              <Route path="relatorios" element={<ComPermissao pagina="relatorios"><Relatorios /></ComPermissao>} />
              <Route path="faturacao" element={<ComPermissao pagina="faturacao"><Faturacao /></ComPermissao>} />
              <Route path="configuracoes" element={<ComPermissao pagina="configuracoes"><Configuracoes /></ComPermissao>} />
              <Route element={<RotaSuper />}>
                <Route path="configuracoes-super" element={<ConfiguracoesSuperAdmin />} />
                <Route path="managers" element={<Managers />} />
                <Route path="permissoes" element={<Permissoes />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default function App() {
  return (
    <ToastProvider>
      <TenantProvider>
        <AppInterna />
      </TenantProvider>
    </ToastProvider>
  )
}

